import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { FileType, GlobalConstantsRegex, GlobalConstantsSonstige, GlobalConstantsTexte, GlobalFunctions, ValueFormat } from 'globales-projekt-angular';
import { AksData } from 'globales-projekt-angular/klassen/aks-data';
import { ModalSchnelleinstellungenComponent } from 'src/app/components/pages/anwendung/modal/modal-schnelleinstellungen/modal-schnelleinstellungen.component';
import { UserWindRichtlinienab } from 'src/app/data/user/user-wind-richtlinienab.model';
import { Gebietskategorie } from 'src/app/data/ws/gebietskategorie.model';
import { WindRichtlinienab } from 'src/app/data/ws/wind-richtlinienab.model';
import { ConstantsTableColsWindRichtlinienab } from 'src/app/immutable/constants-table-cols-wind-richtlinienab';
import { ApiService } from 'src/app/services/api.service';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-winddaten-gebietskategorie',
  templateUrl: './winddaten-gebietskategorie.component.html',
  styleUrls: ['./winddaten-gebietskategorie.component.css']
})
export class WinddatenGebietskategorieComponent implements OnInit {
  tooltipPosition = new FormControl(GlobalConstantsSonstige.POSITION_OPTIONS[0]);

  windhaeufigkeitFormControlList: FormControl[] = [];
  gebietskategorieFormControlList: FormControl[] = [];
  hgFormControlList: FormControl[] = [];

  dataWindRichtlinienabList: MatTableDataSource<WindRichtlinienab> =
    new MatTableDataSource();

  valueFormat: ValueFormat = new ValueFormat();
  filesToUpload: FileList = null;
  windhaeufigkeitSumme: string;

  displayedColsWindRichtlinienab: string[] =
    ConstantsTableColsWindRichtlinienab.getColumns();

  formControlGanzZahlLaeng2OderKomma2NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_2_TEXT);
  formControlGanzZahlLaeng2OderKomma1NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_1_TEXT);
  formControlGanzZahlLaeng4NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_TEXT);

  constructor(
    private apiService: ApiService,
    public localService: LocalService,
    private dialog: MatDialog) {
    this.localService.winddatenGebietskategorieComponentRef.next(this);
  }

  ngOnInit(): void {
    this.getWindRichtlinienab();
  }

  onClickSchnelleinstellungen(): void {
    const dialogRef = this.dialog.open(
      ModalSchnelleinstellungenComponent,
      {
        autoFocus: false,
        width: GlobalConstantsSonstige.BREITE_MODAL_SEHR_GROSS,
        maxWidth: GlobalConstantsSonstige.BREITE_MODAL_SEHR_GROSS,
        disableClose: true,
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== 1) {
        return;
      }

      const aenderungen =
        dialogRef.componentInstance.getWindhaeufigkeitVonBis();

      const windrichtungVon =
        aenderungen.windrichtungVon;

      const windrichtungBis =
        aenderungen.windrichtungBis;

      /*
       * Sollte durch die Dialogvalidierung eigentlich nicht
       * vorkommen, schützt aber trotzdem vor ungültigen Werten.
       */
      if (
        windrichtungVon == null ||
        windrichtungBis == null
      ) {
        return;
      }

      const start: number =
        windrichtungVon / 10;

      const ende: number =
        windrichtungBis / 10 + 1;

      /*
       * Entscheidend ist, ob die jeweilige Eigenschaft
       * überhaupt im Änderungsobjekt vorhanden ist.
       */
      const windhaeufigkeitAendern =
        Object.prototype.hasOwnProperty.call(
          aenderungen,
          'windhaeufigkeit'
        );

      const gebietskategorieAendern =
        Object.prototype.hasOwnProperty.call(
          aenderungen,
          'idGebietskategorie'
        );

      const hgAendern =
        Object.prototype.hasOwnProperty.call(
          aenderungen,
          'hg'
        );

      for (let i = start; i < ende; i++) {
        if (windhaeufigkeitAendern) {
          this.windhaeufigkeitFormControlList[i].setValue(
            this.valueFormat.getStringDecimal(
              aenderungen.windhaeufigkeit,
              0
            )
          );
        }

        if (gebietskategorieAendern) {
          this.gebietskategorieFormControlList[i].setValue(
            aenderungen.idGebietskategorie
          );
        }

        if (hgAendern) {
          this.hgFormControlList[i].setValue(
            this.valueFormat.getStringDecimal(
              aenderungen.hg,
              2
            )
          );
        }
      }
    });
  }

  getWindRichtlinienab() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);

    this.apiService
      .getWindRichtlinienab()
      .subscribe((response) => {
        this.localService.windRichtlinienabList.next(response);

        this.dataWindRichtlinienabList.data = response.map(dto => Object.assign(new WindRichtlinienab(), dto));

        this.windhaeufigkeitFormControlList = [];
        this.hgFormControlList = [];
        this.gebietskategorieFormControlList = [];

        let add: boolean = this.localService.aktuellerUserBetrieb.value.userWindRichtlinienabList.length == 0;

        for (let entry of response) {
          let i: number = entry.windrichtung / 10;

          let userserWindhaeufigkeitRichtlinienabstand: UserWindRichtlinienab = new UserWindRichtlinienab(entry);

          if (add) {
            this.localService.aktuellerUserBetrieb.value.userWindRichtlinienabList.push(userserWindhaeufigkeitRichtlinienabstand);
          }



          this.createAndSetWindhaeufigkeitRichtlinienabstaende(i, this.localService.aktuellerUserBetrieb.value.userWindRichtlinienabList[i]);
        }


        this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
      });
  }


  createAndSetWindhaeufigkeitRichtlinienabstaende(
    i: number,
    userWindRichtlinienab: UserWindRichtlinienab
  ) {
    this.windhaeufigkeitFormControlList[i] = new FormControl(null, [
      Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4),
    ]);

    this.windhaeufigkeitFormControlList[i].setValue(
      this.valueFormat.getStringDecimal(
        userWindRichtlinienab.windhaeufigkeit,
        0
      )
    );

    this.calcWindhaeufigkeit();

    this.windhaeufigkeitFormControlList[i].valueChanges.subscribe(
      (value: string) => {
        this.localService.aktuellerUserBetrieb.value.userWindRichtlinienabList[
          i
        ].windhaeufigkeit = this.valueFormat.parseNumber(value);

        this.calcWindhaeufigkeit();
        this.localService.mainComponentRef.value.checkAndSetButtonState();
      }
    );

    this.hgFormControlList[i] = new FormControl(null, [
      Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_2),
    ]);

    this.hgFormControlList[i].disable();

    this.hgFormControlList[i].setValue(
      this.valueFormat.getStringDecimal(
        userWindRichtlinienab.hg,
        2
      )
    );

    this.hgFormControlList[i].valueChanges.subscribe((value: string) => {
      this.localService.aktuellerUserBetrieb.value.userWindRichtlinienabList[
        i
      ].hg = this.valueFormat.parseNumber(value);

      this.localService.mainComponentRef.value.checkAndSetButtonState();
    });

    this.gebietskategorieFormControlList[i] = new FormControl();

    this.gebietskategorieFormControlList[i].setValue(
      userWindRichtlinienab.idGebietskategorie
    );

    this.gebietskategorieFormControlList[i].valueChanges.subscribe((value) => {
      this.onSelectGebietskategorie(i, value);

      this.localService.aktuellerUserBetrieb.value.userWindRichtlinienabList[
        i
      ].idGebietskategorie = this.valueFormat.parseNumber(value);

      this.localService.mainComponentRef.value.checkAndSetButtonState();
    });
  }

  onSelectGebietskategorie(windrichtung: number, event: number) {
    let gebietskategorie: Gebietskategorie =
      this.localService.globalWSData.value.filter(
        (item) => item.idGebietskategorie == event
      )[0];

    if (gebietskategorie.hg == null) {
      this.hgFormControlList[windrichtung].enable();
      this.hgFormControlList[windrichtung].setValue(
        this.valueFormat.getStringDecimal(0, 2)
      );
    } else {
      this.hgFormControlList[windrichtung].disable();
      this.hgFormControlList[windrichtung].setValue(
        this.valueFormat.getStringDecimal(gebietskategorie.hg, 2)
      );
    }
  }

  calcWindhaeufigkeit() {
    let windhaeufigkeitSumme: number = 0;
    let isNegativ: boolean = false;

    for (let entry of this.localService.aktuellerUserBetrieb.value
      .userWindRichtlinienabList) {
      windhaeufigkeitSumme += entry.windhaeufigkeit;
      if (entry.windhaeufigkeit < 0)
        isNegativ = true;

    }

    if (isNaN(windhaeufigkeitSumme) || isNegativ)
      this.windhaeufigkeitSumme =
        'Ungültig Einträge bei Windhäufigkeit';
    else
      this.windhaeufigkeitSumme = this.valueFormat.getStringDecimal(
        windhaeufigkeitSumme,
        0
      );
    this.localService.mainComponentRef.value.windhaeufigkeitSumme = this.windhaeufigkeitSumme;
  }


  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    this.filesToUpload = input.files;

    if (this.filesToUpload == null || this.filesToUpload.length === 0) {
      return;
    }

    const msg: string = GlobalFunctions.getFilesValidFileTypeMsgString(
      this.filesToUpload,
      [FileType.CSV_EXT, FileType.AKS_EXT],
      [FileType.CSV_SHORT, FileType.AKS_SHORT],
      GlobalConstantsTexte.KEINE_GUELTIGER_DATEITYP_FUER_DATEI
    );

    if (msg.length !== 0) {
      alert(msg);
      input.value = '';
      return;
    }

    const file = this.filesToUpload[0];
    const fileName = file.name.toLowerCase();

    switch (true) {
      case fileName.endsWith(FileType.CSV_EXT):
        await this.readConvertCsv();
        break;

      case fileName.endsWith(FileType.AKS_EXT):
        await this.readConvertAks();

        break;

      default:
        alert(GlobalConstantsTexte.KEINE_GUELTIGER_DATEITYP_FUER_DATEI);
        input.value = '';

    }

    this.localService.mainComponentRef.value.checkAndSetButtonState();

  }

  readConvertCsv(): Promise<void> {
    return GlobalFunctions.convertCsvToData(this.filesToUpload, true)
      .then((dataList) => {
        this.filesToUpload = null;
        let previousFirstColumnValue = -10;

        for (let i = 1; i < dataList.length; i++) {
          const row = dataList[i];

          if (row.length >= 2) {
            const firstColumnValue = parseInt(row[0], 10);
            const secondColumnValue = parseInt(row[1], 10);

            if (firstColumnValue !== previousFirstColumnValue + 10) {
              alert(GlobalFunctions.replacePlatzhalter(
                GlobalConstantsTexte.CSV_AKS_DATEI_UNGUELTIGER_WERT,
                (i + 1).toString(),
                '1',
                firstColumnValue.toString()
              ));
              return;
            } else if (i > 1 && firstColumnValue === previousFirstColumnValue) {
              alert(GlobalFunctions.replacePlatzhalter(
                GlobalConstantsTexte.CSV_AKS_DATEI_UNGUELTIGER_WERT,
                (i + 1).toString(),
                '2',
                secondColumnValue.toString()
              ));
              return;
            }

            previousFirstColumnValue = firstColumnValue;

            this.windhaeufigkeitFormControlList[firstColumnValue / 10].setValue(
              this.valueFormat.getStringDecimal(secondColumnValue, 0)
            );
          }
        }

        alert(GlobalConstantsTexte.EINLESEN_DURCHGEFUEHRT);
      })
      .catch((error) => {
        alert(GlobalFunctions.replacePlatzhalter(
          GlobalConstantsTexte.CSV_AKS_DATEI_FEHLER_EINLESEN,
          error
        ));
      });
  }

  readConvertAks(): Promise<void> {
    return GlobalFunctions.convertAksToData(this.filesToUpload)
      .then((aksFile: AksData) => {
        const columnCount = 36;

        for (let col = 0; col < columnCount; col++) {
          let sum = 0;

          for (let row = 0; row < aksFile.values.length; row++) {
            const rawValue = aksFile.values[row][col];
            const value = parseInt(rawValue, 10);

            if (isNaN(value)) {
              alert(
                GlobalFunctions.replacePlatzhalter(
                  GlobalConstantsTexte.CSV_AKS_DATEI_UNGUELTIGER_WERT,
                  (row + 6).toString(),
                  (col + 1).toString(),
                  rawValue
                )
              );
              return;
            }

            sum += value;
          } 


          const result = sum / 100;

          // AKS-Datei: Spalte 0 = 10°, ..., Spalte 35 = 0°/360°
          // Formular: Index 0 = 0°/360°, Index 1 = 10°, ...
          const targetCol = (col + 1) % columnCount;

          this.windhaeufigkeitFormControlList[targetCol].setValue(
            this.valueFormat.getStringDecimal(result, 0)
          );
        }

        this.filesToUpload = null;
        alert(GlobalConstantsTexte.EINLESEN_DURCHGEFUEHRT);
      })
      .catch((error) => {
        alert(
          GlobalFunctions.replacePlatzhalter(
            GlobalConstantsTexte.CSV_AKS_DATEI_FEHLER_EINLESEN,
            error
          )
        );
      });
  }

  onClickWinddatenExport() {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService
      .postDownloadCsvWinddaten(
        this.localService.aktuellerUserBetrieb.value.userWindRichtlinienabList
      )
      .subscribe((response) => {
        let filename: string = 'Winddaten-Export';

        GlobalFunctions.downloadFile(
          FileType.CSV,
          response,
          filename,
          FileType.CSV_SHORT
        );

        this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
      });
  }

  entfernenInputs() {
    for (let i = 0; i < this.windhaeufigkeitFormControlList.length; i++) {
      this.windhaeufigkeitFormControlList[i].setValue(
        this.valueFormat.getStringDecimal(0, 0)
      );
    }
    for (let i = 0; i < this.hgFormControlList.length; i++) {
      this.hgFormControlList[i].setValue(
        this.valueFormat.getStringDecimal(0, 2)
      );
    }
    for (let i = 0; i < this.gebietskategorieFormControlList.length; i++) {
      this.gebietskategorieFormControlList[i].setValue(
        this.localService.globalWSData.value.find(
          (item) => item.hg === 0
        ).idGebietskategorie
      );

    }
  }

  getIsValid(): boolean {
    const validateControls = (
      name: string,
      controls: Array<any>,
      disabledIsValid: boolean = false
    ): boolean => {

      let isValid = true;

      controls.forEach((control, index) => {
        if (!control) {
          console.warn(`[Validierung] ${name}[${index}] ist nicht vorhanden.`);
          return;
        }

        control.updateValueAndValidity({
          onlySelf: true,
          emitEvent: false
        });

        const controlIsValid =
          (disabledIsValid && !control.enabled) || control.valid;

        if (!controlIsValid) {
          isValid = false;

          console.error(`[Validierung] ${name}[${index}] ist ungültig:`, {
            value: control.value,
            status: control.status,
            enabled: control.enabled,
            errors: control.errors,
            dirty: control.dirty,
            touched: control.touched
          });
        }
      });

      return isValid;
    };

    const windhaeufigkeitValid = validateControls(
      'windhaeufigkeitFormControlList',
      this.windhaeufigkeitFormControlList
    );

    const gebietskategorieValid = validateControls(
      'gebietskategorieFormControlList',
      this.gebietskategorieFormControlList
    );

    const hgValid = validateControls(
      'hgFormControlList',
      this.hgFormControlList,
      true
    );

    const isValid =
      windhaeufigkeitValid &&
      gebietskategorieValid &&
      hgValid;

    console.log('[Validierung] Gesamtergebnis:', {
      isValid,
      windhaeufigkeitValid,
      gebietskategorieValid,
      hgValid
    });

    return isValid;
  }

  public importWinddaten(
    userWindRichtlinienabList: UserWindRichtlinienab[]
  ): void {
    if (!userWindRichtlinienabList?.length) {
      return;
    }

    [...userWindRichtlinienabList]
      .sort((a, b) => a.windrichtung - b.windrichtung)
      .forEach((winddaten: UserWindRichtlinienab, index: number) => {
        this.windhaeufigkeitFormControlList[index]?.setValue(
          this.valueFormat.getStringDecimal(
            winddaten.windhaeufigkeit ?? 0,
            0
          )
        );

        this.hgFormControlList[index]?.setValue(
          this.valueFormat.getStringDecimal(
            winddaten.hg ?? 0,
            2
          )
        );

        this.gebietskategorieFormControlList[index]?.setValue(
          winddaten.idGebietskategorie
        );
      });
  }
}


